import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { isLocalMode } from "../../lib/appMode";
import { PageBackdrop } from "../../components/page-backdrop";

// No signed-in redirect here: verify/forgot/reset must work while signed in.
// signin/signup carry their own redirect. The server-hosted app has one
// auth page: sign-in hands off to the hosted app for everything else.
export const Route = createFileRoute("/auth")({
  beforeLoad: ({ location }) => {
    if (isLocalMode && location.pathname !== "/auth/signin") {
      throw redirect({ to: "/auth/signin", search: { next: undefined } });
    }
  },
  component: AuthLayout,
});

/**
 * Every signed-out page, both apps, one frame (app.css .rago-auth-frame):
 * the wordmark on top, the page centred in what's left, the tagline at the
 * foot, over the same blurred backdrop as the approval popup — so the
 * hosted pages, the server's own sign-in and the popup read as one product.
 *
 * Hosted (Claude Design 4c): the pages sit in one translucent card that
 * stays put while they swap inside it. The server-hosted app (design 3b)
 * has no card: its one page is a few centred lines.
 */
function AuthLayout() {
  return (
    <>
      <PageBackdrop />
      <div className={isLocalMode ? "rago-auth-frame text-center" : "rago-auth-frame"}>
        {isLocalMode ? (
          <p className="rago-wordmark rago-rise text-[32px] leading-none text-[var(--rago-text-1)]">
            RAGO
          </p>
        ) : (
          <a
            href="https://rago.tv"
            className="rago-wordmark rago-rise text-[32px] leading-none text-[var(--rago-text-1)] no-underline"
          >
            RAGO
          </a>
        )}
        <main>
          {isLocalMode ? (
            <Outlet />
          ) : (
            <div className="rago-auth-card rago-rise rago-rise-1">
              <Outlet />
            </div>
          )}
        </main>
        {/* 324px at .2em: tighter under 360px so it never leaves a 320px screen. */}
        <p className="rago-rise rago-rise-3 text-[11.5px] font-medium tracking-[0.2em] whitespace-nowrap text-[var(--rago-text-3)] uppercase max-[359px]:tracking-[0.12em]">
          Your films · Your server · Everywhere
        </p>
      </div>
    </>
  );
}
